"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const ModalHeader = ({ title, onCancel, classNamePrefix }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)('modal-header', 'znd-modal__header', {
        [`${classNamePrefix}__header`]: !!classNamePrefix,
    }) },
    react_1.default.createElement("h3", { className: (0, classnames_1.default)('modal-title', 'znd-modal__title', {
            [`${classNamePrefix}__title`]: !!classNamePrefix,
        }) }, title),
    onCancel ? (react_1.default.createElement("div", { onClick: onCancel, className: (0, classnames_1.default)('znd-modal__close', { [`${classNamePrefix}__close`]: !!classNamePrefix }) },
        react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))) : null));
exports.default = ModalHeader;
